<template>
  <FiltersItem>
    <template #title>
      {{ $l('searchBox.ticketType.label') }}
    </template>

    <template #content>
      <FiltersItemContent>
        <template #content>
          <div class="ticket-type-selector">
            <!-- Vertical line + dots -->
            <div class="timeline">
              <div
                v-for="(label, index) in ticketTypes"
                :key="`dot-${index}`"
                class="timeline-item"
                :class="{ active: isChecked(index) }"
              >
                <div v-if="index !== ticketTypes.length - 1" class="timeline-line" />
                <div class="timeline-dot" />
              </div>
            </div>

            <!-- Labels -->
            <div class="slider-labels">
              <div
                v-for="(label, index) in ticketTypes"
                :key="index"
                class="slider-label"
                :class="{
                  active: isChecked(index),
                }"
                @click="onButtonClick(index)"
              >
                <div class="w-full flex flex-row justify-between relative">
                  <span>{{ label.text }}</span>
                  <span
                    v-if="isCurrentSearchEconomy && index !== 0"
                    class="fetchButton"
                    @click.stop="onFetchClick(index)"
                  >
                    {{ $l('showresult.filter.ticketType.fetch') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </FiltersItemContent>
    </template>
  </FiltersItem>
</template>

<script setup>
import { sleep } from '@js/utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useTicketTypeFilter } from '@v/composables/useTicketTypeFilter';
const filtersStore = useFiltersStore();

const {
	ticketTypes,
	isCurrentSearchEconomy,
	isChecked,
	onButtonClick,
	onFetchClick,
	getTicketTypesFromIndex
} = useTicketTypeFilter();

onMounted(async () => {
	const initialIndex = ticketTypes.value.findIndex(t => t.key === window.js_params?.classType);
	const isFilterSet = filtersStore.get.value?.ticketType?.length > 0;

	if (initialIndex !== 0 && !isFilterSet) {
		await sleep(1);
		filtersStore.set({
			key: 'ticketType',
			value: getTicketTypesFromIndex(initialIndex)
		});
	}
});
</script>

<style lang="scss" scoped>
.fetchButton {
  padding: 0.25rem 0.5rem;
  font-size: 1.1rem;
  color: $white;
  background-color: $color-blue-900;
  border: 0.1rem solid $color-blue-900;
  border-radius: $borderRadius-sm;
  transition: background-color 0.2s ease;
  margin: -0.5rem -.75rem;
  height: 2.25rem;
  align-items: center;
  display: flex;
  width: 4.75rem;
  justify-content: center;
}

.ticket-type-selector {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  padding: 1rem 0;
}

.timeline {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.timeline-item {
  position: relative;
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-line {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.2rem;
  height: 100%;
  background-color: $color-blue-300;
  transform: translateX(-50%);
  z-index: 0;
  transition: background-color 0.3s ease;
}

.timeline-item.active .timeline-line {
  background-color: $color-blue-700;
}


.timeline-dot {
  width: 1.2rem;
  height: 1.2rem;
  border: 0.2rem solid $color-blue-300;
  border-radius: 50%;
  background-color: $white;
  position: relative;
  z-index: 1;
  transition: border-color 0.2s ease;
}
.timeline-item.active .timeline-dot {
  border-color: $color-blue-700;
  transition: border-color 0.4s ease;
  border-color: $color-blue-700;
  background-color: $white;
}

.slider-labels {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.slider-label {
  position: relative;
  overflow: hidden;
  min-height: 3rem;
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  line-height: 1.3rem;
  color: $disabled-font-color;
  padding: 0.75rem 1rem;
  border: 0.1rem solid $color-blue-300;
  border-radius: $borderRadius-md;
  cursor: pointer;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.slider-label.active {
  color: $color-blue-900;
  border-color: $color-blue-700;
  background-color: $color-blue-100;
  border: none;
}

@include breakpoint_up('md') {
  .slider-label {
    border-radius: $borderRadius-sm;
  }
}
</style>
